<template>
    <b-container id="project-schema-page" fluid>
        <b-row class="">
            <b-col cols="12">
                <div class="border-bottom mb-3 pb-3">
                    <h3>프로젝트 스키마 관리</h3>
                    <p class="fw-400 text-secondary mb-0">
                        프로젝트별 입력 스키마 및 다국어 문자열을 관리합니다.
                    </p>
                </div>
            </b-col>
        </b-row>

        <b-tabs v-model="currentTab" card>
            <b-tab :title="$t('스키마 입력 값 관리')">
                <manage-schema-input/>
            </b-tab>
            <b-tab :title="$t('다국어 문자열 관리')">
                <manage-locale-string/>
            </b-tab>
        </b-tabs>
    </b-container>
</template>

<script>

import ManageLocaleString
    from '@shared/components/admin/pages/Management/ProjectSchema/LocaleString/ManageLocaleString.vue';
import ManageSchemaInput
    from '@shared/components/admin/pages/Management/ProjectSchema/SchemaInput/ManageSchemaInput.vue';

export default {
    name: 'ProjectSchema',
    components: {
        ManageSchemaInput,
        ManageLocaleString
    },
    data() {
        const mapTabName = {
            0: 'schemaInput',
            1: 'localeString',
        };
        // URL 의 ?tab= 을 초기 탭으로 반영 (CampaignConnectRule 과 동일 이유).
        const tabToIndex = {schemaInput: 0, localeString: 1};
        const initialTab = tabToIndex[this.$route.query.tab] ?? 0;
        return {
            currentTab: initialTab,
            mapTabName
        };
    },
    computed: {},
    watch: {
        currentTab: {
            handler() {
                const nextTab = this.mapTabName[this.currentTab];
                if (this.$route.query.tab === nextTab) return;
                this.$router.push({
                    name: 'ManagingProjectSchema',
                    query: {tab: nextTab}
                });
            },
            immediate: true
        }
    },
    created() {
    },
    beforeDestroy() {
    },
    methods: {}
};
</script>

<style lang="scss">
</style>
